<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import axios from 'axios';
import { ref, onMounted, computed } from 'vue';
import { authHeader } from "../../helpers/authservice/auth-header";
import '@jobinsjp/vue3-datatable/dist/style.css';
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import store from "../../state/store";
import 'vue-select/dist/vue-select.css';
import moment from "moment";
import MediaViewer from "../../components/general-search/media-viewer.vue";
import NovViewer from "../../components/general-search/nov-viewer.vue";
import Timeline from "../../components/general-search/timeline.vue";
import ViolationInformation from "../../components/general-search/traffic-record/violation-information.vue";
import LtoRecord from "../../components/general-search/traffic-record/lto-record.vue";
import Violations from "../../components/general-search/traffic-record/violations.vue";
import Ovr from "../../components/general-search/ovr/ovr.vue";
import ViolationPenaltyMatrix from "../../components/general-search/ovr/violation-penalty-matrix.vue";
import Swal from 'sweetalert2';

const user = computed(() => store.state.auth.user);
const loading = computed(() => store.state.globals.loading);
const isSearch = ref(false);

const rejectedRecordDetailsModalTab = ref(0);
const filters = ref([]);
const traffic_record_ids = ref([]);
const pagination = ref({
  per_page: 10,
  total: 11,
  page: 1
});

const selectedRejectedRecord = ref(null);
const selectedTrafficRecords = ref([]);
const title = ref("Rejected Record");
const items = ref([
  {
    text: "Home",
    href: "/"
  },
  {
    text: "Traffic Record",
  },
  {
    text: "Rejected Record",
    active: true,
  }
]);
const userRoles = computed(() => JSON.parse(localStorage.getItem('roles')));

const roleExist = (slug) => {
  if (userRoles.value && userRoles.value.length) {
      return userRoles.value.some((obj) => (obj.slug === slug));
  }

  return false;
}

const clickSearch = async (dt) => {
  if (dt.per_page) {
    pagination.value.per_page = dt.per_page;
  }

  store.dispatch('globals/loading', null, { root: true });
  filters.value = [];

  try {
    const { data } = await axios.get(`/rejected-record/${user.value.id}/filter`, {
      params: { 
        page: dt.page,
        pageSize: pagination.value.per_page
      }
    })

    pagination.value.page =  data.current_page;
    pagination.value.total = data.total;
    if (data.per_page) {
        pagination.value.per_page = data.per_page;
    }

    if (data.data.length) {
      filters.value = data.data;
      selectedTrafficRecords.value = [];
    }

    traffic_record_ids.value = [];

    isSearch.value = true;
    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
    isSearch.value = false;
    store.dispatch('globals/loaded', null, { root: true });
  }
}

const getRejectedRecordDetails = async (row) => {
  if (!row) return;

  store.dispatch('globals/loading', null, { root: true });

  try {
    selectedRejectedRecord.value = row;

    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    const { message } = err.response.data;
    store.dispatch('globals/loaded', null, { root: true });
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message
    })
  }
}

const toggleAll = async () => {
  if (traffic_record_ids.value.length == filters.value.length) {
    traffic_record_ids.value = []; 
    return;
  }

  if(filters.value.length){
    traffic_record_ids.value = []; 
    filters.value.forEach(function (filter){
      traffic_record_ids.value.push(filter.traffic_record.id)
    });
  }
} 

const toggleSelect = async (id) => {
    if(!traffic_record_ids.value.includes(id)){
      traffic_record_ids.value.push(id)
    } else {
      traffic_record_ids.value.splice(traffic_record_ids.value.indexOf(id),1)
    }
} 

const reject = async () => {

    const confirm = await Swal.fire({
        icon: 'info',
        title: 'Continue?',
        text: `Do you want to reject ${(traffic_record_ids.value.length != 0 ? traffic_record_ids.value.length : pagination.value.total)} traffic record(s)?`,
        showCancelButton: true,
        confirmButtonText: 'Yes',
    })

  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  try {
    await axios.post(`/rejected-record/${user.value.id}/filter/reject`, {
      traffic_record_ids: traffic_record_ids.value
    }, {
      headers: authHeader()
    });

    if(traffic_record_ids.value.length!=0){
        await clickSearch(pagination.value);
        Swal.fire("Success", `Successfully rejected!` , "success");
    }else{
        Swal.fire("Success", `Rejecting record files are queued!` , "success");
    }

    store.dispatch('globals/loaded', null, { root: true });
  } catch(err) {
    const { message } = err.response.data;
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message
    })
    store.dispatch('globals/loaded', null, { root: true });
  }
}

const resetRejectedRecordDetails = () => {
    rejectedRecordDetailsModalTab.value = 0;
    selectedRejectedRecord.value = null;
}

onMounted(async () => {
    await clickSearch(pagination.value);
});
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="loading">
          <div class="card">
              <div class="card-body">
                <div v-if="!isSearch" class="text-center">
                  <div class="row justify-content-center mt-5 mb-2">
                    <div class="col-sm-7 col-8">
                      <img src="@/assets/images/file.png" alt="" class="img-fluid" width="400">
                    </div>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="row" v-if="filters.length">
                      <div class="col-12">
                          <div class="card">
                          <div class="card-body overflow-auto">
                              <div class="row justify-content-md-center">
                              <div class="col-12 col-md-12">
                                  <div class="row justify-content-md-center">
                                  <div class="col-12">
                                      <button @click.prevent="reject" type="button" class="mr-2 w-100 btn btn-danger">{{traffic_record_ids.length ? "Reject Selected" : "Reject All"}}</button>
                                  </div>
                                  </div>
                              </div>
                              </div>
                          </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-12">
                    <data-table
                      :rows="filters"
                      striped
                      :pagination="pagination"
                      :loading="loading"
                      hoverable
                      @loadData="clickSearch"
                    >

                      <template #thead>
                          <table-head @click="toggleAll()">
                            <template v-if="filters.length && traffic_record_ids.length == filters.length">
                              <input type="checkbox" checked> 
                            </template>
                            <template v-else>
                              <input type="checkbox"> 
                            </template>
                          </table-head>
                          <table-head>File #</table-head>
                          <table-head>Status</table-head>
                          <table-head>Violation Date</table-head>
                          <table-head>Violation Time</table-head>
                          <table-head>Location</table-head>
                          <table-head>Camera ID</table-head>
                        </template>

                      <template #tbody="{row}">
                          <table-body @click="toggleSelect(row.traffic_record.id)">
                            <template v-if="traffic_record_ids.includes(row.traffic_record.id)">
                              <input type="checkbox" :value="row.traffic_record.id" checked> 
                            </template>
                            <template v-else>
                              <input type="checkbox" :value="row.traffic_record.id"> 
                            </template>
                          </table-body>
                          <table-body>
                            <template v-if="row && row.traffic_record.filename">
                              <div @click="getRejectedRecordDetails(row)" class="text-info" data-bs-toggle="modal" data-bs-target="#rejectedRecordDetailsModal">{{ row.traffic_record.filename ? row.traffic_record.filename : '' }}</div>
                            </template>
                            <template v-else>
                              n/a
                            </template>
                          </table-body>
                          <table-body :class="(row.traffic_record.status.includes('Rejected')) ? 'fs-12 text-danger': (row.traffic_record.status.includes('Approved')) ? 'fs-12 text-success': 'fs-12'">
                                {{ row.traffic_record.reject_reason}}
                          </table-body>
                          <table-body>{{ row && row.traffic_record.timestamp ? moment(row.traffic_record.timestamp).format('MMMM DD, YYYY') : 'n/a' }}</table-body>
                          <table-body>{{ row && row.traffic_record.timestamp ? moment(row.traffic_record.timestamp).format('hh:mm:ss A') : 'n/a' }}</table-body>
                          <table-body>{{ row && row.traffic_record.violation_information ? row.traffic_record.violation_information.location || 'n/a' : 'n/a' }}</table-body>
                          <table-body>{{ row && row.traffic_record.violation_information ? row.traffic_record.violation_information.camera_id || 'n/a' : 'n/a' }}</table-body>
                      </template>

                      <template #empty>
                      <TableBodyCell colspan="6">
                          No results found!
                      </TableBodyCell>
                    </template>
                  </data-table>
                  </div>  
                </div>
            </div><!-- end card-body -->
          </div>
        </b-overlay>
      </div>
    </div>
    <div id="rejectedRecordDetailsModal" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-labelledby="rejectedRecordDetailsModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog modal-xl modal-fullscreen-lg-down">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editRecordModalLabel">Rejected Record Details</h5>
            <button type="button" @click="resetRejectedRecordDetails" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
          </div>
          <div class="modal-body">
            <b-overlay :show="loading">
              <b-tabs v-model="rejectedRecordDetailsModalTab" tag="ul" class="nav-success nav-tabs-custom pl-0" content-class="mt-3" v-if="selectedRejectedRecord">
                <b-tab title="Media">
                  <div class="row" v-if="selectedRejectedRecord.media.length">
                    <MediaViewer :medias="selectedRejectedRecord.media" :traffic_record="selectedRejectedRecord.media" />
                  </div>
                  <div class="row" v-else>
                    <h4>No media files found</h4>
                  </div>
                </b-tab>
                <b-tab title="Traffic Record" class="bg-light">
                  <div class="row gx-0">
                    <div class="col-md-12 col-lg-6">
                      <ViolationInformation :violation_information="selectedRejectedRecord.traffic_record.violation_information" />
                      <Violations :violations="selectedRejectedRecord.traffic_record.violations"/>
                    </div>
                    <div class="col-md-12 col-lg-6">
                        <LtoRecord :lto_record="selectedRejectedRecord.traffic_record.lto_record" />
                    </div>
                  </div>
                </b-tab>
                <b-tab v-if="roleExist('lto-record')" title="NOV">
                    <div class="row">
                      <div class="col-md-12 mb-1">
                        <NovViewer :nov="selectedRejectedRecord.nov" />
                      </div>
                    </div>
                </b-tab>
                <b-tab title="OVR" class="bg-light">
                    <div class="row gx-0">
                      <div class="col-md-12 col-lg-6">
                        <Ovr :ovr="selectedRejectedRecord.ovr.ovr" />
                      </div>
                      <div class="col-md-12 col-lg-6">
                        <Violations :violations="selectedRejectedRecord.ovr.violations"/>
                      </div>
                        <div class="col-md-12">
                        <ViolationPenaltyMatrix :violation_penalty_matrix="selectedRejectedRecord.ovr.violation_penalty_matrix"/>
                      </div>
                    </div>
                </b-tab>
                <b-tab v-if="roleExist('timeline')" title="Timeline" class="bg-light">
                  <div class="row">
                    <div v-if="selectedRejectedRecord.timeline" class="col-md-12">
                        <Timeline :timeline="selectedRejectedRecord.timeline"/>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-overlay>
          </div>
          <div class="modal-footer">
            <button type="button" @click="resetRejectedRecordDetails" class="btn btn-danger" data-bs-dismiss="modal">
              <i class="mdi mdi-close mr-1 align-middle"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
